/**
 * Do not edit this file it is auto-generated by io-utils / gen-api-models.
 * See https://github.com/pagopa/io-utils
 */
/* eslint-disable  */

import * as t from "io-ts";

// required attributes
const TransferR = t.interface({});

// optional attributes
const TransferO = t.partial({
  abi: t.string,

  bundleDescription: t.string,

  bundleName: t.string,

  idBrokerPsp: t.string,

  idBundle: t.string,

  idChannel: t.string,

  idCiBundle: t.string,

  idPsp: t.string,

  onUs: t.boolean,

  paymentMethod: t.string,

  primaryCiIncurredFee: t.Integer,

  taxPayerFee: t.Integer,

  touchpoint: t.string,

  pspBusinessName: t.string
});

export const Transfer = t.intersection([TransferR, TransferO], "Transfer");

export type Transfer = t.TypeOf<typeof Transfer>;
